<template>
    <div class="common_container">
        <el-form :model="form" label-width="80px" class="event-form">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="知识来源">
                        <el-select v-model="form.AuditStatus" placeholder="请选择" class="form-input">
                            <el-option v-for="item in KnowledgeStatus" :key="item.id" :label="item.cname"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="submit">提交</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import commonService from "../../services/common.service";
    import services from "./knowledge.service";
    import { getRules } from "./knowledge.rules";
    const rules = getRules();
    export default {
        props:{
            message:Object,
            callback:Function
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            // 知识状态
            KnowledgeStatus(){
                return this.dictionary.KnowledgeAuditStatus;
            },
        },
        data() {
            return {
                formName:"form",
                rules:rules,
                form:{
                    AuditStatus:"",
                    KnowledgeId:'',
                    Version:'',
                },
                knowledgeOrigin:[],//知识来源
                // AuditStatus:[
                //     { id:"289",name:"待审核"},
                //     { id:"291",name:"发布"},
                //     { id:"293",name:"审核不通过"},
                //     { id:"295",name:"废止"},
                // ],//
            }
        },
        created() {
            // this.getKnowledgeOrigin();
            this.form.AuditStatus = ""+this.message.AuditStatus;
            this.form.KnowledgeId = this.message.KnowledgeId;
            this.form.Version = this.message.Version;
        },
        methods: {
            // 获取知识来源
            // getKnowledgeOrigin(){
            //     services.knowledgeOrigin().then(res => {
            //         this.knowledgeOrigin = res;
            //     })
            // },
            submit(){
                // let AuditStatus=+this.form.AuditStatus
                // console.log(222222);
                // this.form={
                //     ...this.form,
                //     AuditStatus:AuditStatus
                // }
                this.form.AuditStatus = Number(this.form.AuditStatus);
                services.knowledgeAudit(this.form).then(res=>{
                    this.$message.success("审批成功");
                    this.close(true);
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
